import { useAsyncDataRequestStatus } from '@/composables/utils/useAsyncDataRequestStatus';
import { useMicroCMSDetailParams } from '@/composables/utils/useMicroCMSDetailParams';
import type { EnExperienceResponse, EnExperienceViewModel } from '@/models/enExperience';
import { buildEnExperienceViewModel, createDefaultEnExperienceViewModel } from '@/models/enExperience';
import { useMicroCMSGetListDetail } from '@/wabunka-src/common/composables/query/useMicroCMSClient';

import type { AsyncDataRequestStatus } from '#app';

/**
 * pathとqueryからdedupe用のkeyの組み立てを行う
 */
const buildKey = (path: string, query?: object, server?: boolean) => {
  return path + (query ? ',query=' + JSON.stringify(query) : '') + (server ? ',server' : ',client');
};

/**
 * 英語版体験詳細の取得に使用する Composable
 * Page でのみ使用可能
 */
export const useEnExperience = async (server: boolean = false) => {
  const { contentId, draftKeyQuery } = useMicroCMSDetailParams();

  const { data, status }: { data: Ref<EnExperienceResponse | null>; status: Ref<AsyncDataRequestStatus> } = await useMicroCMSGetListDetail<EnExperienceResponse>(
    {
      endpoint: 'en-experiences',
      contentId: contentId.value,
      queries: { ...draftKeyQuery?.value },
    },
    {
      key: buildKey('en-experiences', { contentId: contentId.value, ...draftKeyQuery?.value }, server),
      server: server,
    },
  );

  const enExperience = computed<EnExperienceViewModel>(() => (data.value ? buildEnExperienceViewModel(data.value) : createDefaultEnExperienceViewModel()));

  return { enExperience, ...useAsyncDataRequestStatus(status) };
};
